import { render } from "./B2bPageFacturasTerceros.vue?vue&type=template&id=1d940287&scoped=true&lang=pug"
import script from "./B2bPageFacturasTerceros.vue?vue&type=script&lang=js"
export * from "./B2bPageFacturasTerceros.vue?vue&type=script&lang=js"

import "./B2bPageFacturasTerceros.vue?vue&type=style&index=0&id=1d940287&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d940287"]])

export default __exports__